<template>
  <div>
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading" class="table-container">
        <export-options
          :exportUrl="exportUrl"
          :repository="repository"
          :resource="resource"
          :tableRef="$refs[tableRef]"
          :filter="filter"
          :options="[
            {
              code: 'REGIFOCA',
              label: null,
              formats: ['csv', 'pdf'],
            },
          ]"
        ></export-options>
        <book-entry
          :isTableInModal="true"
          :fields="fields"
          :repository="repository"
          :resource="resource"
          :filterName="filterName"
          :ref="tableRef"
          noActions
          noInnerWidth
          noInputPaginator
          noPagination
          includeBottomRow
          sortField="book_date"
          :descending="true"
          @edit="onEdit"
          :filterOn="{
            byRelations: [
              'byBroker',
              'byTask',
              'byInsurer',
              'byInsuranceAncillary',
              'byVariousAccounting',
              'byInsurerAccounting',
              'byRegistry',
            ],
          }"
        ></book-entry>
      </div>
      <template #overlay>
        <div class="text-center mt-5">
          <base-icon name="loading" width="35" height="35"/>
          <p id="cancel-label">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import {toLocaleCurrency} from "@/utils/strings";
import {toLocaleDate} from "@/utils/dates";
import ExportOptions from "@/components/ExportOptions";
import BaseIcon from "@/components/BaseIcon";
import BookEntry from "@/components/tables/BookEntries";
import DetailTabAutofetchTableMixin from "@/mixins/DetailTabAutofetchTableMixin";
import FilterAndSortMixin from "../../../../mixins/FilterAndSortMixin";

export default {
  mixins: [DetailTabAutofetchTableMixin, FilterAndSortMixin],
  name: "Accounting",
  props: {
    resourceId: Number,
  },
  data() {
    return {
      exportUrl: null,
      filter: this.initFilter(),
      isLoading: false,
      insuranceAncillariesIds: [],
      tableRef: "BookEntriesDetailTableRef",
      filterName: "filterBookEntriesDetail",
      resource: "book_entries",
      repository: "book_entry",
      fields: [
        {
          key: "book_date",
          label: this.getDictionary("book_date", "book_entry"),
          sortable: true,
          sortKey: "book_date",
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "effective_date",
          label: this.getDictionary("effective_date", "book_entry"),
          sortable: true,
          sortKey: "effective_date",
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "insurer.formatted_title",
          label: this.getDictionary("title", "insurer"),
        },
        {
          key: "insurance_policy_number",
          label: this.getDictionary("insurance_policy_number", "book_entry"),
        },
        {
          key: "branch",
          label: this.getDictionary("title", "risk_branch"),
          sortable: false,
        },
        {
          key: "prodotto_incassi",
          label: this.getDictionary("insurance_risk"),
          sortable: false,
        },
        {
          key: "document_code",
          label: this.getDictionary("code", "book_tag"),
        },
        {
          key: "customer",
          label: this.getDictionary("registry"),
          sortable: false,
        },
        {
          key: "gross",
          label: this.getDictionary("gross", "book_entry"),
          sortable: true,
          sortKey: "gross",
          formatter: (value) => toLocaleCurrency(value),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "agency_gross",
          label: this.getDictionary("Provv. Agenzia"),
          sortable: false,
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "saler_gross",
          label: this.getDictionary("Provv. Produttore"),
          sortable: false,
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "broker",
          label: this.getDictionary("broker", "book_entry"),
        },
      ],
    };
  },
  methods: {
    initFilter() {
      let init = {
        byInsurancePolicy: {id: this.resourceId},
      };
      return init;
    },
    onSearch(name) {
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName
      );
    },
    onEdit(item, onlyEditBroker = false) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: {
          id: `${item.id}`,
          item: item,
          mode: "I",
          type: "edit",
          onlyEditBroker: onlyEditBroker,
        },
      });
    },
  },
  components: {
    BaseIcon,
    BookEntry,
    ExportOptions,
  },
  beforeMount() {
    this.onSearch(this.filterName);
  },
};
</script>
